export const b64toBlob = (b64Data: string, contentType='', sliceSize=512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];
 
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
 
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
 
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
 
  const blob = new Blob(byteArrays, {type: contentType});
  return blob;
}

export async function getAsByteArray(file: any) {
  return new Uint8Array(await readFile(file) as any)
}

function readFile(file: any) {
  return new Promise((resolve, reject) => {
      // Create file reader
      let reader = new FileReader()
      // Register event listeners
      reader.addEventListener("loadend", e => resolve(e.target?.result))
      reader.addEventListener("error", reject)
      // Read file
      reader.readAsArrayBuffer(file)
  })
}